$(document).ready(function () {
  $('.open-modal').click(function (e) {
    e.preventDefault();
    const modalId = $(this).attr('data-modal');
    $('#' + modalId).addClass('show-terms-modal');
  });

  $('.pin-campaign__modal-close').click(function () {
    $(this).closest('.pin-campaign__modal').removeClass('show-terms-modal');
  });

  $(document).click(function (event) {
    if ($(event.target).hasClass('pin-campaign__modal')) {
      $(event.target).removeClass('show-terms-modal');
    }
  });
});

// Updates pin campaign progress bar color
document.addEventListener('DOMContentLoaded', function () {
  function updateProgressBarStyles() {
    const campaignForm = document.getElementById('page-content-campaign-form');
    const numberElement = document.querySelector(
      '.pin-campaign__progress-bar-number--2'
    );
    const textElement = document.querySelector(
      '.pin-campaign__progress-bar-text--confirmation'
    );

    if (campaignForm && numberElement && textElement) {
      const isVisible =
        window.getComputedStyle(campaignForm).display !== 'none';

      numberElement.style.backgroundColor = isVisible ? '#D9D9D9' : '#1c1d1d';
      numberElement.style.color = isVisible ? '#666666' : '#FFFFFF';
      textElement.style.color = isVisible ? '#666666' : '#1c1d1d';
    }
  }

  // Run on page load
  updateProgressBarStyles();

  // Observe changes to the element's style
  const observer = new MutationObserver(updateProgressBarStyles);
  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
  });
});

// Updates pin campaign birthdate placeholder color
$(document).ready(function () {
  $('.pin-campaign-form__select[type="date"]')
    .on('input change', function () {
      if ($(this).val()) {
        $(this).css('color', '#1c1d1d');
      } else {
        $(this).css('color', '#808080');
      }
    })
    .trigger('change');
});

if (document.querySelector('.pin-campaign__page-wrapper')) {
  document.documentElement.style.scrollBehavior = 'auto';
}

function toggleProductsCarousel() {
  const campaignForm = document.getElementById('page-content-campaign-form');
  const productsCarousel = document.getElementById(
    'pin-campaign-form__products-carousel'
  );
  const formTerms = document.querySelector('.pin-campaign-form__terms-wrapper');
  const contestRulesWrapper = document.querySelector(
    '.pin-campaign__contest-rules-wrapper'
  );
  const termsContent = document.querySelector(
    '.pin-campaign-form__terms-content'
  );

  if (
    campaignForm &&
    productsCarousel &&
    formTerms &&
    contestRulesWrapper &&
    termsContent
  ) {
    const isVisible = campaignForm.style.display !== 'none';

    if (!isVisible) {
      productsCarousel.classList.add('products-carousel-visible');
      formTerms.style.backgroundColor = '#F6F6F6';
      contestRulesWrapper.style.backgroundColor = '#F6F6F6';
      termsContent.style.backgroundColor = '#F6F6F6';
      setTimeout(() => {
        $('#pin-campaign-form__products-carousel').slick('setPosition');
      }, 300);
    } else {
      productsCarousel.classList.remove('products-carousel-visible');
    }
  }
}

const campaignFormObserver = new MutationObserver(() => {
  toggleProductsCarousel();
});

const campaignFormElement = document.getElementById(
  'page-content-campaign-form'
);

if (campaignFormElement) {
  campaignFormObserver.observe(campaignFormElement, {
    attributes: true,
    attributeFilter: ['style'],
  });
}

toggleProductsCarousel();
